import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { pager } from './pager.function';
import { Paging } from '../../api/types/Pageable';

const offsetToPage = (offset: number, limit: number) => Math.floor(offset / limit) + 1;

@Component({
  selector: 'app-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagerComponent implements OnChanges {
  @Input() totalPagesCount: number;
  @Input() page: number;
  @Input() size: number;
  @Input() variant: 'default' | 'theme' = 'default';

  @Output() paginate = new EventEmitter<Paging>();

  pagesList: number[] = [];
  selectedPage = 1;
  visiblePages: number;

  private pager = pager(this.getPageRangeByScreenSize());

  ngOnChanges(changes: SimpleChanges) {
    this.selectedPage = this.page + 1;
    const paginationResults = this.pager(this.totalPagesCount || 0, this.selectedPage);
    this.pagesList = paginationResults.pagesList;
    // this.totalPagesCount = paginationResults.totalPagesCount;
    this.visiblePages = paginationResults.visiblePages;
  }

  get showFirstPage(): boolean {
    return this.pagesList[0] > 1;
  }

  get showFirstPageDots(): boolean {
    return this.pagesList[0] - 1 > 1;
  }

  get showLastPage(): boolean {
    return this.pagesList[this.pagesList.length - 1] < this.totalPagesCount;
  }

  get showLastPageDots(): boolean {
    return this.totalPagesCount - this.pagesList[this.pagesList.length - 1] > 1;
  }

  goTo(page: any) {
    if (typeof page === 'number') {
      this.paginate.emit({
        page: (page - 1),
        size: this.size
      });
    }
  }

  private getPageRangeByScreenSize() : number {
    let pageRange = 5;
    let widthScreen = window.innerWidth;

    if (widthScreen <= 576) {
      pageRange = 1;
    }

    if (widthScreen > 576 && widthScreen <= 768) {
      pageRange = 3;
    }

    return pageRange;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.pager = pager(this.getPageRangeByScreenSize());
    this.ngOnChanges(null);
  }

  getClass() {
    return this.variant === 'theme' ? 'page-theme' : 'page-default';
  }
}
